import { AuthContext } from "@/auth/authcontext";
import { NavUser } from "@/components/nav/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import { useProjects } from "@/hooks/api/use-projects";
import { FolderKanban } from "lucide-react";
import * as React from "react";
import { useContext } from "react";
import { Link, useLocation } from "react-router";
import { NavMain } from "./nav-main";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const { data: projects } = useProjects();

  const projectItems = [
    {
      title: "Projects",
      url: "/projects",
      icon: FolderKanban,
      isActive: location.pathname.startsWith("/projects"),
      items: [
        ...(projects?.map((project) => ({
          title: project.name,
          url: `/projects/${project.id}`,
          isActive: location.pathname === `/projects/${project.id}`,
        })) || []),
      ],
    },
  ];

  return (
    <Sidebar variant="sidebar" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link to="/">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                  EA
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">EveryAd</span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent className="mt-4">
        <NavMain items={projectItems} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            first_name: user?.first_name || "",
            last_name: user?.last_name || "",
            email: user?.email || "",
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
